let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4mSCT")).then(() => parcelRequire('jhs0g'));